export default __webpack_public_path__ + "static/media/miguel-lopes-12.3cd44658.jpg";